import { createContext, useContext } from 'react';
import { TIconRenderer } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconRendererContext = createContext<TIconRenderer<any> | null>(
  null,
);

export function useIconRendererContext<
  P extends Record<string, unknown> = Record<string, unknown>,
>() {
  const context = useContext(IconRendererContext);

  if (!context) throw new Error('There is no IconRendererContext');

  return context as TIconRenderer<P>;
}
